(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Pavlina"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (sec.classList.contains('pav-ready')) return;
    sec.classList.add('pav-ready', 'is-armed');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    var els = sec.querySelectorAll('.pav-reveal');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (e) { io.observe(e); });
  }
  function all() { document.querySelectorAll('[data-pav]').forEach(init); }
  if (document.readyState !== 'loading') { all(); } else { document.addEventListener('DOMContentLoaded', all); }
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-pav]'); if (s) init(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crystals"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(sec) {
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    var els = sec.querySelectorAll('.cx-reveal');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });
  }

  function build3D(sec) {
    var canvas = sec.querySelector('[data-cryx-canvas]');
    if (!canvas || typeof THREE === 'undefined') return;
    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(55, 1, 0.1, 100);
    camera.position.set(0, 0, 12);
    scene.add(new THREE.AmbientLight(0xffffff, 0.45));
    var key = new THREE.PointLight(0xffe3f5, 1.1, 80); key.position.set(6, 8, 12); scene.add(key);
    var rim = new THREE.PointLight(0xff5fc0, 1.0, 80); rim.position.set(-10, -6, 4); scene.add(rim);
    var group = new THREE.Group(); scene.add(group);
    var palette = [0xc23a93, 0x8a2bbf, 0xb02a86, 0xd96cb4, 0x6e1f9c];
    var geoms = [new THREE.OctahedronGeometry(1, 0), new THREE.IcosahedronGeometry(1, 0)];
    var crystals = [], count = window.innerWidth < 700 ? 7 : 11, i, col, mat, m, s, ex;
    for (i = 0; i < count; i++) {
      col = palette[i % palette.length];
      mat = new THREE.MeshStandardMaterial({ color: col, flatShading: true, metalness: 0.25, roughness: 0.25, emissive: new THREE.Color(col).multiplyScalar(0.10), transparent: true, opacity: 0.72 });
      m = new THREE.Mesh(geoms[i % geoms.length], mat);
      s = 0.45 + Math.random() * 1.7;
      m.scale.set(s, s * (1.2 + Math.random() * 0.7), s);
      ex = (Math.random() < 0.5 ? -1 : 1) * (5 + Math.random() * 5);
      m.position.set(ex, (Math.random() - 0.5) * 12, (Math.random() - 0.5) * 7 - 2);
      m.rotation.set(Math.random() * 6, Math.random() * 6, Math.random() * 6);
      m.userData = { rx: (Math.random() - 0.5) * 0.004, ry: (Math.random() - 0.5) * 0.005, fy: 0.25 + Math.random() * 0.5, ph: Math.random() * 6, by: m.position.y };
      group.add(m); crystals.push(m);
    }
    var nn = window.innerWidth < 700 ? 220 : 420, pos = new Float32Array(nn * 3);
    for (i = 0; i < nn; i++) {
      pos[i * 3] = (Math.random() - 0.5) * 30;
      pos[i * 3 + 1] = (Math.random() - 0.5) * 20;
      pos[i * 3 + 2] = (Math.random() - 0.5) * 16;
    }
    var pg = new THREE.BufferGeometry();
    pg.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    var dust = new THREE.Points(pg, new THREE.PointsMaterial({ size: 0.045, color: 0xffc7ec, transparent: true, opacity: 0.5, blending: THREE.AdditiveBlending, depthWrite: false }));
    scene.add(dust);
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    var prog = 0, tprog = 0, mx = 0, my = 0, tx = 0, ty = 0;
    window.addEventListener('pointermove', function (e) { tx = e.clientX / window.innerWidth - 0.5; ty = e.clientY / window.innerHeight - 0.5; });
    var scrollProg = function () { var r = sec.getBoundingClientRect(); var h = sec.offsetHeight - window.innerHeight; tprog = Math.min(1, Math.max(0, (-r.top) / (h || 1))); };
    window.addEventListener('scroll', scrollProg); scrollProg();
    var resize = function () { var w = canvas.clientWidth, h = canvas.clientHeight; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); };
    window.addEventListener('resize', resize); resize();
    function loop(t) {
      if (!sec.isConnected) { renderer.dispose(); return; }
      var time = t * 0.001, c, j;
      prog += (tprog - prog) * 0.06;
      for (j = 0; j < crystals.length; j++) {
        c = crystals[j];
        if (!reduce) { c.rotation.x += c.userData.rx; c.rotation.y += c.userData.ry; }
        c.position.y = c.userData.by + Math.sin(time * c.userData.fy + c.userData.ph) * 0.5;
      }
      if (!reduce) { dust.rotation.y += 0.0005; }
      mx += (tx - mx) * 0.05; my += (ty - my) * 0.05;
      group.rotation.y = mx * 0.4 + prog * Math.PI * 0.6;
      group.rotation.x = my * 0.25 + prog * 0.3;
      camera.position.x = mx * 1.3; camera.position.y = -my * 0.9; camera.lookAt(0, 0, 0);
      renderer.render(scene, camera);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  function init(sec) {
    if (sec.classList.contains('cryx-ready')) return;
    sec.classList.add('cryx-ready', 'is-armed');
    reveal(sec);
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce) return;
    (function wait() { if (typeof THREE !== 'undefined') { build3D(sec); } else { setTimeout(wait, 80); } })();
  }
  function all() { document.querySelectorAll('[data-crystals]').forEach(init); }
  if (document.readyState !== 'loading') { all(); } else { document.addEventListener('DOMContentLoaded', all); }
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-crystals]'); if (s) init(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-crystals"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    var root = document.querySelector('[data-xhero]');
    if (!root) return;
    var canvas = root.querySelector('[data-xhero-canvas]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (typeof THREE === 'undefined' || !canvas) return;

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(55, 1, 0.1, 100);
    camera.position.set(0, 0, 11);

    scene.add(new THREE.AmbientLight(0x4a2050, 1.1));
    var key = new THREE.PointLight(0xff3fb4, 1.5, 60); key.position.set(8, 6, 10); scene.add(key);
    var rim = new THREE.PointLight(0x7be0ff, 0.9, 60); rim.position.set(-9, -4, 6); scene.add(rim);
    var top = new THREE.DirectionalLight(0xffffff, 0.5); top.position.set(0, 10, 4); scene.add(top);

    var group = new THREE.Group(); scene.add(group);
    var palette = [0xdd159b, 0xff66c4, 0x9b2fd1, 0xff9ad8, 0xc01a86];
    var geoms = [new THREE.OctahedronGeometry(1, 0), new THREE.IcosahedronGeometry(1, 0), new THREE.OctahedronGeometry(1, 0)];
    var crystals = [];
    var count = window.innerWidth < 700 ? 6 : 9;
    var i, col, mat, m, s;
    for (i = 0; i < count; i++) {
      col = palette[i % palette.length];
      mat = new THREE.MeshStandardMaterial({ color: col, flatShading: true, metalness: 0.35, roughness: 0.18, emissive: new THREE.Color(col).multiplyScalar(0.18), transparent: true, opacity: 0.92 });
      m = new THREE.Mesh(geoms[i % geoms.length], mat);
      s = 0.5 + Math.random() * 1.5;
      m.scale.set(s, s * (1.2 + Math.random() * 0.6), s);
      m.position.set((Math.random() - 0.5) * 15, (Math.random() - 0.5) * 9, (Math.random() - 0.5) * 6 - 1);
      m.rotation.set(Math.random() * 6, Math.random() * 6, Math.random() * 6);
      m.userData = { rx: (Math.random() - 0.5) * 0.0045, ry: (Math.random() - 0.5) * 0.0055, fy: 0.3 + Math.random() * 0.5, ph: Math.random() * 6, by: m.position.y };
      group.add(m); crystals.push(m);
    }

    var n = window.innerWidth < 700 ? 260 : 480;
    var positions = new Float32Array(n * 3);
    for (i = 0; i < n; i++) {
      positions[i * 3] = (Math.random() - 0.5) * 26;
      positions[i * 3 + 1] = (Math.random() - 0.5) * 16;
      positions[i * 3 + 2] = (Math.random() - 0.5) * 14;
    }
    var pg = new THREE.BufferGeometry();
    pg.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    var dust = new THREE.Points(pg, new THREE.PointsMaterial({ size: 0.05, color: 0xffc7ec, transparent: true, opacity: 0.85, blending: THREE.AdditiveBlending, depthWrite: false }));
    scene.add(dust);

    var mx = 0, my = 0, tx = 0, ty = 0;
    window.addEventListener('pointermove', function (e) {
      tx = e.clientX / window.innerWidth - 0.5;
      ty = e.clientY / window.innerHeight - 0.5;
    });

    function resize() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }
    function loop(t) {
      var time = t * 0.001, c, j;
      for (j = 0; j < crystals.length; j++) {
        c = crystals[j];
        if (!reduce) { c.rotation.x += c.userData.rx; c.rotation.y += c.userData.ry; }
        c.position.y = c.userData.by + Math.sin(time * c.userData.fy + c.userData.ph) * 0.45;
      }
      if (!reduce) { dust.rotation.y += 0.0006; }
      mx += (tx - mx) * 0.05; my += (ty - my) * 0.05;
      group.rotation.y = mx * 0.5; group.rotation.x = my * 0.35;
      camera.position.x = mx * 1.6; camera.position.y = -my * 1.1; camera.lookAt(0, 0, 0);
      renderer.render(scene, camera);
      requestAnimationFrame(loop);
    }
    window.addEventListener('resize', resize);
    resize();
    requestAnimationFrame(loop);
  }
  function wait() {
    if (typeof THREE !== 'undefined') { boot(); } else { setTimeout(wait, 80); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wait);
  } else {
    wait();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-short"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (sec.classList.contains('msx-ready')) return;
    sec.classList.add('msx-ready', 'is-armed');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    var els = sec.querySelectorAll('.msx-reveal');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (e) { io.observe(e); });
  }
  function all() { document.querySelectorAll('[data-msx]').forEach(init); }
  if (document.readyState !== 'loading') { all(); } else { document.addEventListener('DOMContentLoaded', all); }
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-msx]'); if (s) init(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    var sec = document.querySelector('[data-cipm]');
    if (!sec) return;
    var canvas = sec.querySelector('[data-cipm-canvas]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

    if (typeof THREE !== 'undefined' && canvas) {
      var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(55, 1, 0.1, 100);
      camera.position.set(0, 0, 12);
      scene.add(new THREE.AmbientLight(0xffffff, 0.45));
      var key = new THREE.PointLight(0xffe3f5, 1.1, 80); key.position.set(6, 8, 12); scene.add(key);
      var rim = new THREE.PointLight(0xff5fc0, 1.0, 80); rim.position.set(-10, -6, 4); scene.add(rim);
      var group = new THREE.Group(); scene.add(group);
      var palette = [0xc23a93, 0x8a2bbf, 0xb02a86, 0xd96cb4, 0x6e1f9c];
      var geoms = [new THREE.OctahedronGeometry(1, 0), new THREE.IcosahedronGeometry(1, 0)];
      var crystals = [], count = window.innerWidth < 700 ? 7 : 11, i, col, mat, m, s, ex;
      for (i = 0; i < count; i++) {
        col = palette[i % palette.length];
        mat = new THREE.MeshStandardMaterial({ color: col, flatShading: true, metalness: 0.25, roughness: 0.25, emissive: new THREE.Color(col).multiplyScalar(0.10), transparent: true, opacity: 0.72 });
        m = new THREE.Mesh(geoms[i % geoms.length], mat);
        s = 0.45 + Math.random() * 1.7;
        m.scale.set(s, s * (1.2 + Math.random() * 0.7), s);
        ex = (Math.random() < 0.5 ? -1 : 1) * (5 + Math.random() * 5);
        m.position.set(ex, (Math.random() - 0.5) * 12, (Math.random() - 0.5) * 7 - 2);
        m.rotation.set(Math.random() * 6, Math.random() * 6, Math.random() * 6);
        m.userData = { rx: (Math.random() - 0.5) * 0.004, ry: (Math.random() - 0.5) * 0.005, fy: 0.25 + Math.random() * 0.5, ph: Math.random() * 6, by: m.position.y };
        group.add(m); crystals.push(m);
      }
      var nn = window.innerWidth < 700 ? 260 : 460, pos = new Float32Array(nn * 3);
      for (i = 0; i < nn; i++) {
        pos[i * 3] = (Math.random() - 0.5) * 30;
        pos[i * 3 + 1] = (Math.random() - 0.5) * 20;
        pos[i * 3 + 2] = (Math.random() - 0.5) * 16;
      }
      var pg = new THREE.BufferGeometry();
      pg.setAttribute('position', new THREE.BufferAttribute(pos, 3));
      var dust = new THREE.Points(pg, new THREE.PointsMaterial({ size: 0.045, color: 0xffc7ec, transparent: true, opacity: 0.5, blending: THREE.AdditiveBlending, depthWrite: false }));
      scene.add(dust);
      var prog = 0, tprog = 0, mx = 0, my = 0, tx = 0, ty = 0;
      window.addEventListener('pointermove', function (e) { tx = e.clientX / window.innerWidth - 0.5; ty = e.clientY / window.innerHeight - 0.5; });
      var scrollProg = function () { var r = sec.getBoundingClientRect(); var h = sec.offsetHeight - window.innerHeight; tprog = Math.min(1, Math.max(0, (-r.top) / (h || 1))); };
      window.addEventListener('scroll', scrollProg); scrollProg();
      var resize = function () { var w = canvas.clientWidth, h = canvas.clientHeight; renderer.setSize(w, h, false); camera.aspect = w / h; camera.updateProjectionMatrix(); };
      var loop = function (t) {
        var time = t * 0.001, c, j;
        prog += (tprog - prog) * 0.06;
        for (j = 0; j < crystals.length; j++) {
          c = crystals[j];
          if (!reduce) { c.rotation.x += c.userData.rx; c.rotation.y += c.userData.ry; }
          c.position.y = c.userData.by + Math.sin(time * c.userData.fy + c.userData.ph) * 0.5;
        }
        if (!reduce) { dust.rotation.y += 0.0005; }
        mx += (tx - mx) * 0.05; my += (ty - my) * 0.05;
        group.rotation.y = mx * 0.4 + prog * Math.PI * 0.85;
        group.rotation.x = my * 0.25 + prog * 0.35;
        camera.position.z = 12 - prog * 4;
        camera.position.x = mx * 1.3; camera.position.y = -my * 0.9; camera.lookAt(0, 0, 0);
        renderer.render(scene, camera);
        requestAnimationFrame(loop);
      };
      window.addEventListener('resize', resize); resize(); requestAnimationFrame(loop);
    }

    // progressive text reveal (gated so copy is never hidden without JS)
    var targets = [];
    sec.querySelectorAll('.cipm-reveal').forEach(function (el) { targets.push(el); });
    var body = sec.querySelector('.cipm__body');
    if (body) { body.querySelectorAll('p').forEach(function (p) { p.classList.add('cipm-reveal'); targets.push(p); }); }
    sec.classList.add('is-armed');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.25 });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('in'); });
    }
  }
  function wait() { if (typeof THREE !== 'undefined') { boot(); } else { setTimeout(wait, 80); } }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', wait); } else { wait(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["readings"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

  function cycleQuestions(root){
    var qs = root.querySelectorAll('.read__q');
    if(!qs.length) return;
    if(reduce){ qs[0].classList.add('in'); return; }
    var i = 0;
    (function step(){
      var el = qs[i];
      el.classList.remove('out'); el.classList.add('in');
      setTimeout(function(){
        el.classList.remove('in'); el.classList.add('out');
        i = (i+1) % qs.length;
        setTimeout(step, 850);
      }, 3200);
    })();
  }

  function build(root){
    var canvas = root.querySelector('.read__scene');
    if(!canvas) return;
    var period = (parseFloat(root.getAttribute('data-period')) || 13) * 1000;

    var renderer = new THREE.WebGLRenderer({canvas:canvas, alpha:true, antialias:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(52, 1, 0.1, 100);
    camera.position.set(0,0,9);
    scene.add(new THREE.AmbientLight(0xffffff, 0.7));
    var l1=new THREE.PointLight(0xffe3f5,1.3,90); l1.position.set(6,7,10); scene.add(l1);
    var l2=new THREE.PointLight(0xff5fc0,1.1,90); l2.position.set(-9,-5,5); scene.add(l2);
    var l3=new THREE.PointLight(0xf5c451,0.7,90); l3.position.set(0,-6,6); scene.add(l3);

    function cardTex(){
      var c=document.createElement('canvas'); c.width=256; c.height=420; var x=c.getContext('2d');
      var g=x.createLinearGradient(0,0,0,420); g.addColorStop(0,'#7a1158'); g.addColorStop(1,'#2a0822');
      x.fillStyle=g; x.fillRect(0,0,256,420);
      x.strokeStyle='#f5c451'; x.lineWidth=9; x.strokeRect(15,15,226,390);
      x.lineWidth=2; x.strokeRect(28,28,200,364);
      x.save(); x.translate(128,210); x.fillStyle='#f5c451';
      for(var i=0;i<12;i++){ x.rotate(Math.PI/6); x.beginPath(); x.moveTo(0,-78); x.lineTo(9,-34); x.lineTo(-9,-34); x.closePath(); x.fill(); }
      x.beginPath(); x.arc(0,0,28,0,Math.PI*2); x.fillStyle='#fff3d0'; x.fill();
      x.beginPath(); x.arc(0,0,18,0,Math.PI*2); x.fillStyle='#dd159b'; x.fill();
      x.restore();
      return new THREE.CanvasTexture(c);
    }
    var tex=cardTex();
    var goldMat=new THREE.MeshStandardMaterial({color:0xcaa24a, metalness:0.6, roughness:0.35});
    function makeCard(){
      var faceMat=new THREE.MeshStandardMaterial({map:tex, roughness:0.5, metalness:0.1, transparent:true, opacity:1});
      var mats=[goldMat.clone(),goldMat.clone(),goldMat.clone(),goldMat.clone(),faceMat,faceMat.clone()];
      return new THREE.Mesh(new THREE.BoxGeometry(1.5,2.5,0.05), mats);
    }
    var cards=new THREE.Group(); scene.add(cards);
    var cardList=[];
    for(var i=0;i<5;i++){
      var card=makeCard();
      card.position.set((i-2)*1.5,0,0);
      card.rotation.set(0,(i-2)*0.18,(i-2)*0.05);
      card.userData={ph:i*0.7, baseRot:(i-2)*0.18};
      cards.add(card); cardList.push(card);
    }

    var ball=new THREE.Group(); scene.add(ball);
    var glass=new THREE.Mesh(new THREE.SphereGeometry(1.7,48,48),
      new THREE.MeshStandardMaterial({color:0xffd6f5, transparent:true, opacity:0.22, roughness:0.05, metalness:0, emissive:0x7a1052, emissiveIntensity:0.4}));
    var core=new THREE.Mesh(new THREE.SphereGeometry(0.8,32,32),
      new THREE.MeshBasicMaterial({color:0xff8fd8, transparent:true, opacity:0.65}));
    var base=new THREE.Mesh(new THREE.CylinderGeometry(0.95,1.25,0.5,40), goldMat.clone());
    base.position.y=-2.15;
    var innerN=160, ip=new Float32Array(innerN*3);
    for(i=0;i<innerN;i++){ var r=Math.random()*1.3, th=Math.random()*6.28, ph=Math.acos(2*Math.random()-1);
      ip[i*3]=r*Math.sin(ph)*Math.cos(th); ip[i*3+1]=r*Math.sin(ph)*Math.sin(th); ip[i*3+2]=r*Math.cos(ph); }
    var ipg=new THREE.BufferGeometry(); ipg.setAttribute('position', new THREE.BufferAttribute(ip,3));
    var inner=new THREE.Points(ipg, new THREE.PointsMaterial({size:0.05, color:0xffd0ee, transparent:true, opacity:0.9, blending:THREE.AdditiveBlending, depthWrite:false}));
    ball.add(glass,core,inner,base);
    ball.scale.set(0.2,0.2,0.2);

    var dn=420, dp=new Float32Array(dn*3);
    for(i=0;i<dn;i++){ dp[i*3]=(Math.random()-0.5)*34; dp[i*3+1]=(Math.random()-0.5)*22; dp[i*3+2]=(Math.random()-0.5)*18; }
    var dpg=new THREE.BufferGeometry(); dpg.setAttribute('position', new THREE.BufferAttribute(dp,3));
    var dust=new THREE.Points(dpg, new THREE.PointsMaterial({size:0.04, color:0xffd9b0, transparent:true, opacity:0.45, blending:THREE.AdditiveBlending, depthWrite:false}));
    scene.add(dust);

    var mx=0,my=0,tx=0,ty=0,scroll=0;
    function onMove(e){ tx=e.clientX/window.innerWidth-0.5; ty=e.clientY/window.innerHeight-0.5; }
    function onScroll(){ var r=root.getBoundingClientRect(); scroll=Math.max(-1,Math.min(1,(window.innerHeight*0.5-(r.top+r.height*0.5))/window.innerHeight)); }
    window.addEventListener('pointermove', onMove);
    window.addEventListener('scroll', onScroll); onScroll();
    function resize(){ var w=canvas.clientWidth, h=canvas.clientHeight; renderer.setSize(w,h,false); camera.aspect=w/h; camera.updateProjectionMatrix(); }
    window.addEventListener('resize', resize); resize();

    function smooth(a,b,t){ t=Math.max(0,Math.min(1,t)); t=t*t*(3-2*t); return a+(b-a)*t; }
    function weight(p){ if(p<0.42)return 0; if(p<0.5)return (p-0.42)/0.08; if(p<0.92)return 1; return 1-(p-0.92)/0.08; }

    var start=performance.now();
    function loop(now){
      if(!root.isConnected){ renderer.dispose(); return; }
      var t=(now-start)*0.001;
      var p=((now-start)%period)/period;
      var w=weight(p); w=w*w*(3-2*w);
      var co=1-w;

      for(var k=0;k<cardList.length;k++){ var cd=cardList[k];
        if(!reduce){
          cd.position.y=Math.sin(t*0.8+cd.userData.ph)*0.18;
          cd.rotation.y=cd.userData.baseRot+Math.sin(t*0.5+cd.userData.ph)*0.12;
          cd.rotation.z=Math.sin(t*0.4+cd.userData.ph)*0.04;
        }
        cd.material.forEach(function(mm){ mm.opacity=co; mm.transparent=true; });
      }
      cards.scale.setScalar(smooth(1.05,0.7,w));
      cards.position.y=smooth(0,1.2,w);
      cards.visible=co>0.02;

      ball.scale.setScalar(smooth(0.2,1.0,w));
      glass.material.opacity=0.22*w; core.material.opacity=0.65*w; inner.material.opacity=0.9*w;
      base.material.opacity=w; base.material.transparent=true;
      ball.visible=w>0.02;
      if(!reduce){ ball.rotation.y+=0.004; inner.rotation.y-=0.01; inner.rotation.x+=0.004; core.scale.setScalar(1+Math.sin(t*2)*0.06); }
      if(!reduce) dust.rotation.y+=0.0004;

      mx+=(tx-mx)*0.05; my+=(ty-my)*0.05;
      camera.position.x=mx*1.4;
      camera.position.y=-my*1.0 - scroll*1.4;
      camera.position.z=smooth(9,6.4,w);
      camera.lookAt(0, smooth(0,0.1,w), 0);
      renderer.render(scene,camera);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  function initOne(root){
    if(root.classList.contains('is-init')) return;
    root.classList.add('is-init');
    cycleQuestions(root);
    if(typeof THREE !== 'undefined'){ build(root); }
    else { window.addEventListener('load', function(){ if(typeof THREE !== 'undefined') build(root); }); }
  }
  function initAll(){
    if(typeof THREE === 'undefined'){ setTimeout(initAll, 80); }
    var list=document.querySelectorAll('[data-readings]');
    for(var i=0;i<list.length;i++) initOne(list[i]);
  }

  if(document.readyState!=='loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var r=e.target.querySelector('[data-readings]');
    if(r){ r.classList.remove('is-init'); initOne(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tarot-readings"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (sec.classList.contains('tarot-ready')) return;
    sec.classList.add('tarot-ready', 'is-armed');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    var els = sec.querySelectorAll('.tr-reveal');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });
  }
  function all() { document.querySelectorAll('[data-tarot]').forEach(init); }
  if (document.readyState !== 'loading') { all(); } else { document.addEventListener('DOMContentLoaded', all); }
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-tarot]'); if (s) init(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function splitTitle(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var text = el.textContent;
    el.textContent = '';
    text.split('').forEach(function (ch, i) {
      var s = document.createElement('span');
      s.className = 'wel__char';
      s.textContent = (ch === ' ') ? '\u00A0' : ch;
      s.style.transitionDelay = (0.18 + i * 0.045) + 's';
      el.appendChild(s);
    });
  }

  function starfield(sec) {
    var canvas = sec.querySelector('[data-wel-canvas]');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, stars = [], shoot = null;
    function build() {
      var n = Math.max(40, Math.round(w * h / 9000));
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.4 + 0.3, a: Math.random() * 6.28, tw: Math.random() * 0.03 + 0.006, vx: (Math.random() - 0.5) * 0.06, vy: (Math.random() - 0.5) * 0.06 });
      }
    }
    function resize() {
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      build();
    }
    function draw() {
      if (!sec.isConnected) return;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i], al;
        if (!reduce) {
          s.a += s.tw; al = 0.35 + Math.abs(Math.sin(s.a)) * 0.65;
          s.x += s.vx; s.y += s.vy;
          if (s.x < 0) s.x += w; if (s.x > w) s.x -= w;
          if (s.y < 0) s.y += h; if (s.y > h) s.y -= h;
        } else { al = 0.7; }
        ctx.globalAlpha = al; ctx.fillStyle = '#ffe9f7';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.2832); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (!reduce) {
        if (!shoot && Math.random() < 0.005) {
          shoot = { x: Math.random() * w * 0.7, y: Math.random() * h * 0.4, len: 0, maxLen: Math.random() * 130 + 90, sp: Math.random() * 6 + 7, ang: Math.PI * 0.2 };
        }
        if (shoot) {
          var dx = Math.cos(shoot.ang), dy = Math.sin(shoot.ang);
          shoot.x += dx * shoot.sp; shoot.y += dy * shoot.sp;
          shoot.len = Math.min(shoot.maxLen, shoot.len + shoot.sp * 2.2);
          var gx = shoot.x - dx * shoot.len, gy = shoot.y - dy * shoot.len;
          var g = ctx.createLinearGradient(shoot.x, shoot.y, gx, gy);
          g.addColorStop(0, 'rgba(255,224,247,.95)'); g.addColorStop(1, 'rgba(255,224,247,0)');
          ctx.strokeStyle = g; ctx.lineWidth = 2; ctx.lineCap = 'round';
          ctx.beginPath(); ctx.moveTo(shoot.x, shoot.y); ctx.lineTo(gx, gy); ctx.stroke();
          if (shoot.x > w + 60 || shoot.y > h + 60) shoot = null;
        }
      }
      requestAnimationFrame(draw);
    }
    window.addEventListener('resize', resize);
    resize(); requestAnimationFrame(draw);
  }

  function init(sec) {
    if (sec.classList.contains('wel-ready')) return;
    sec.classList.add('wel-ready', 'is-armed');
    var title = sec.querySelector('.wel__title');
    if (title) splitTitle(title);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sec.querySelectorAll('.wel__char').forEach(function (c) { c.classList.add('in'); });
        sec.querySelectorAll('.wel-reveal').forEach(function (e) { e.classList.add('in'); });
      });
    });
    starfield(sec);
  }
  function all() { document.querySelectorAll('[data-welcome]').forEach(init); }
  if (document.readyState !== 'loading') { all(); } else { document.addEventListener('DOMContentLoaded', all); }
  document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-welcome]'); if (s) init(s); });
})();

  } catch(e) { console.error(e); }
})();
})();
